import React, { useEffect } from "react";
import CandidatesList from "../../candidate/CandidatesList";

function PoliticiansPage(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="homepage-container">
      <div className="home-tab">
        <CandidatesList divisions={props.divisions} />
      </div>
    </div>
  );
}

export default PoliticiansPage;